<template>
    <competitions></competitions>

</template>

<script>
    import Competitions from "../content/club/competition/Competitions";
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        name: "CompetitionsPage",
        components: {Competitions},
        directives: {
            Resize, Scroll
        },
        mounted() {
            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)
        }
    }
</script>

